import { render, staticRenderFns } from "./vehicle-detail.vue?vue&type=template&id=48034fe4"
import script from "./vehicle-detail.vue?vue&type=script&lang=js"
export * from "./vehicle-detail.vue?vue&type=script&lang=js"
import style0 from "./vehicle-detail.vue?vue&type=style&index=0&id=48034fe4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports